export const TRANSLATIONS_NO = {
  "routes_Pages": "Sider",
  "routes_Dashboard": "Dashbord",
  "routes_Questionnaire": "Standarder",
  "routes_Stats": "Statistikk",
  "routes_Settings": "Innstillinger",
  "routes_Resouces": "Ressurser",
  "routes_Contact": "Kontakt",
  "routes_Downloads": "Nedlastinger",
  "routes_Documentation": "Dokumentasjon",
  "dashboard_welcome_message": "Velkommen til dashbordet for tilgjengelighetsstyringssystem 👋",
  "dashboard_label": "Alle tilgjengelighetsdataene dine samlet, strukturert og overvåket på ett sted.",
  "gettingStartedCard_gettingStarted": "Starter",
  "gettingStartedCard_gettinStartedDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elementum dui nunc, ac porta sem consequat nec. Pellentesk",
  "gettingStartedCard_Steps": "Vi anbefaler disse trinnene til å begynne med:",
  "gettingStartedCard_step1": "Les dokumentasjonen",
  "gettingStartedCard_step2": "Last ned sjekklisten",
  "gettingStartedCard_step3": "Sjekk statistikken din",
  "companyCard_supportedStandards": "Støttede standarder:",
  "companyCard_companyInformation": "firmainformasjon",
  "companyCard_numberOfEmployees": "ansatte",
  "propertyListPage_propertyList": "Eiendomsliste",
  "propertyListPage_dashboard": "Dashbord",
  "propertyListPage_Questionnaire": "Standarder",
  "propertyListPage_newProperty": "Ny eiendom",
  "propertyListPage_textmapEdit": "Rediger egenskap",
  "propertyListPage_textmapQuestionnaire": "Klassifisere",
  "propertyListPage_textmapFacility": "Rediger anlegg",
  "propertyListPage_textmapNewProperty": "Ny eiendom",
  "propertyListPage_createNewProperty": "Opprett ny eiendom",
  "propertyListPage_disabilityClassification": "Klassifisering av funksjonshemming",
  "propertyListPage_editProperty": "Rediger egenskap",
  "propertyListPage_editFacilities": "Rediger fasiliteter",
  "propertyListPage_classify": "Klassifisere",
  "propertyListPage_search": "Søk etter eiendomsnavn",
  "propertyForm_propertyInformation": "1.1 Eiendomsinformasjon",
  "propertyForm_standardType": "Standard type",
  "propertyForm_fieldCannotBeChanged": "Dette feltet kan ikke endres",
  "propertyForm_propertyCategory": "Eiendomskategori",
  "propertyForm_typeOfProperty": "Type eiendom",
  "propertyForm_propertyName": "Eiendomsnavn",
  "propertyForm_propertyArea": "Mengde kvadratmeter gulvflate",
  "propertyForm_enterPropertyAddress": "1.1.2 Angi eiendomsadresse",
  "propertyForm_addressLocation": "Skriv inn adressen nedenfor",
  "propertyForm_mapNote": "Om nødvendig kan du justere kartet slik at pinnen er på rett plassering",
  "propertyForm_keyPropertyData": "1.2 Viktige eiendomsdata",
  "propertyForm_floorsQuestion": "Hvor mange etasjer har eiendommen din?",
  "propertyForm_roomsQuestion": "Hvor mange rom har eiendommen din?",
  "propertyForm_disabledRoomsQuestion": "Hvor mange funksjonshemmede rom har eiendommen din?",
  "propertyForm_alergyRoomsQuestion": "Hvor mange allergirom har boligen din?",
  "propertyForm_save": "Lagre",
  "propertyForm_propertyHotelTypeOptionsLabel_Hotel": "Hotell",
  "propertyForm_propertyHotelTypeOptionsLabel_Motel": "Motell",
  "propertyForm_propertyConvenienceStoreOptions_Candies": "Godterier",
  "propertyForm_propertyConvenienceStoreOptions_Newspapers": "Aviser",
  "propertyForm_propertyConvenienceStoreOptions_TobaccoProducts": "Tabaksprodukter",
  "propertyForm_propertyConvenienceStoreOptions_Toiletries": "Toalettsaker",
  "propertyForm_propertyConvenienceStoreOptions_Store": "butikk",
  "propertyForm_propertyConvenienceStoreOptions_Supermarket": "Supermarked",
  "propertyForm_propertyDepartmentStoreOptions_Clothing": "Klær",
  "propertyForm_propertyDepartmentStoreOptions_DepartmentStore": "Kjøpesenter",
  "propertyForm_propertyDepartmentStoreOptions_Electronics": "Elektronikk",
  "propertyForm_propertyDepartmentStoreOptions_Garden": "Hage",
  "propertyForm_propertyDepartmentStoreOptions_Household_goods": "Innbo",
  "propertyForm_propertyDepartmentStoreOptions_Pets": "Kjæledyr",
  "propertyForm_propertyDepartmentStoreOptions_Toys": "Leker",
  "propertyForm_propertyFoodAndDrinkOptions_bakery_and_baked_goods_store": "Bakeri og bakevarebutikk",
  "propertyForm_propertyFoodAndDrinkOptions_dairy_goods": "Meierivarer",
  "propertyForm_propertyFoodAndDrinkOptions_food_and_drink": "Mat og Drikke",
  "propertyForm_propertyFoodAndDrinkOptions_food_beverage_specialty_store": "Spesialbutikk for mat og drikke",
  "propertyForm_propertyFoodAndDrinkOptions_grocery": "Dagligvare",
  "propertyForm_propertyFoodAndDrinkOptions_meat": "Kjøtt",
  "propertyForm_propertyFoodAndDrinkOptions_specialty_food_store": "Spesialmatbutikk",
  "propertyForm_propertyFoodAndDrinkOptions_Vegan": "Vegansk",
  "propertyForm_propertyFoodAndDrinkOptions_Vegetarian": "Vegetarisk",
  "propertyForm_propertyFoodAndDrinkOptions_wine_and_liquor": "Vin og brennevin",
  "propertyForm_propertyDrugstoreOptions_drugstore": "Apotek",
  "propertyForm_propertyDrugstoreOptions_pharmacy": "Apotek",
  "propertyForm_propertyElectronicsOptions_computer_and_software": "Datamaskin og programvare",
  "propertyForm_propertyElectronicsOptions_consumer_electronics_store": "Forbrukerelektronikkbutikk",
  "propertyForm_propertyElectronicsOptions_electronics": "Elektronikk",
  "propertyForm_propertyElectronicsOptions_entertainment_electronics": "Underholdningselektronikk",
  "propertyForm_propertyElectronicsOptions_mobile_retailer": "Mobilforhandler",
  "propertyForm_propertyElectronicsOptions_mobile_service_center": "Mobilt servicesenter",
  "propertyForm_propertyMallOptions_shopping_gallery_mall": "Kjøpesenter",
  "propertyForm_propertyMallOptions_shopping_mall": "Kjøpesenter",
  "propertyForm_standardTypeOptions_hotel_motel": "Hotell/Motell",
  "propertyForm_standardTypeOptions_shopping_mall": "Kjøpesenter",
  "propertyForm_standardTypeOptions_shop": "Butikk",
  "propertyForm_propertyHardwareOptions_floor_and_carpet": "Gulv og teppe",
  "propertyForm_propertyHardwareOptions_furniture_store": "Møbel butikk",
  "propertyForm_propertyHardwareOptions_garden_center": "Hagesenter",
  "propertyForm_propertyHardwareOptions_glass_and_window": "Glass og vindu",
  "propertyForm_propertyHardwareOptions_hardware_house_garden": "Jernvarehus hage",
  "propertyForm_propertyHardwareOptions_home_improvement_hardware_store": "Byggevarebutikk for oppussing",
  "propertyForm_propertyHardwareOptions_home_specialty_store": "Hjem spesialbutikk",
  "propertyForm_propertyHardwareOptions_lumber": "Tømmer",
  "propertyForm_propertyHardwareOptions_major_appliance": "Større apparat",
  "propertyForm_propertyHardwareOptions_paint_store": "Malingsbutikk",
  "propertyForm_propertyHardwareOptions_power_equipment_dealer": "Forhandler av kraftutstyr",
  "propertyForm_propertyBookstoreOptions_bookstore": "Bokhandel",
  "propertyForm_propertyClothingOptions_childrens_apparel": "Barneklær",
  "propertyForm_propertyClothingOptions_clothing_and_accessories": "Klær og tilbehør",
  "propertyForm_propertyClothingOptions_mens_apparel": "Herreklær",
  "propertyForm_propertyClothingOptions_shoes_footwear": "Sko fottøy",
  "propertyForm_propertyClothingOptions_specialty_clothing_store": "Spesialbutikk for klær",
  "propertyForm_propertyClothingOptions_womens_apparel": "Dameklær",
  "propertyForm_consumerGoodsOptions_adult_shop": "Voksenbutikk",
  "propertyForm_consumerGoodsOptions_arts_and_crafts_supplies": "Kunst og håndverk forsyninger",
  "propertyForm_consumerGoodsOptions_bicycle_and_bicycle_accessories_shop": "Sykkel og sykkeltilbehør butikk",
  "propertyForm_consumerGoodsOptions_camping_hiking_shop": "Campingturbutikk",
  "propertyForm_consumerGoodsOptions_canoe_kayak_shop": "Kano kajakk butikk",
  "propertyForm_consumerGoodsOptions_car_accessories": "Bil tilbehør",
  "propertyForm_consumerGoodsOptions_consumer_goods": "Forbruksvarer",
  "propertyForm_consumerGoodsOptions_cross_country_ski_shop": "Langrennsbutikk",
  "propertyForm_consumerGoodsOptions_florist": "Blomsterhandler",
  "propertyForm_consumerGoodsOptions_general_merchandise": "Generelle handelsvarer",
  "propertyForm_consumerGoodsOptions_gift_antique_art": "Gave antikk kunst",
  "propertyForm_consumerGoodsOptions_hobby_store": "Hobbybutikk",
  "propertyForm_consumerGoodsOptions_hunting_fishing_shop": "Jaktfiskebutikk",
  "propertyForm_consumerGoodsOptions_jeweler": "Gullsmed",
  "propertyForm_consumerGoodsOptions_market": "Marked",
  "propertyForm_consumerGoodsOptions_motorcycle_accessories": "Motorsykkel tilbehør",
  "propertyForm_consumerGoodsOptions_non_store_retailers": "Ikke-butikkforhandlere",
  "propertyForm_consumerGoodsOptions_office_supply_store": "Kontorrekvisitabutikk",
  "propertyForm_consumerGoodsOptions_pawnshop": "Pantelåner",
  "propertyForm_consumerGoodsOptions_pet_supply": "Kjæledyrsforsyning",
  "propertyForm_consumerGoodsOptions_record_cd_video": "Ta opp cd-video",
  "propertyForm_consumerGoodsOptions_running_walking_shop": "Løpende gåbutikk",
  "propertyForm_consumerGoodsOptions_skate_shop": "Skatebutikk",
  "propertyForm_consumerGoodsOptions_ski_snowboard_shop": "Ski snowboard butikk",
  "propertyForm_consumerGoodsOptions_specialty_store": "Spesialbutikk",
  "propertyForm_consumerGoodsOptions_sporting_goods_store": "Sportsbutikk",
  "propertyForm_consumerGoodsOptions_surf_shop": "Surfebutikk",
  "propertyForm_consumerGoodsOptions_tack_shop": "Takbutikk",
  "propertyForm_consumerGoodsOptions_toy_store": "Lekebutikk",
  "propertyForm_consumerGoodsOptions_used_second_hand_merchandise_stores": "Brukt bruktvarebutikker",
  "propertyForm_consumerGoodsOptions_variety_store": "Variasjonsbutikk",
  "propertyForm_consumerGoodsOptions_video_and_game_rental": "Video- og spillutleie",
  "propertyForm_consumerGoodsOptions_warehouse_wholesale_store": "Lager engros butikk",
  "propertyForm_hairAndBeautyOptions_barber": "Barber",
  "propertyForm_hairAndBeautyOptions_hair_and_beauty": "Hår og skjønnhet",
  "propertyForm_hairAndBeautyOptions_hair_salon": "Frisørsalong",
  "propertyForm_hairAndBeautyOptions_nail_salon": "Negl salong",
  "propertyForm_hairAndBeautyOptions_make_up_salon": "Sminkesalong",
  "propertyForm_mallTopCategoryOptions_mall_shopping_complex": "Kjøpesenter kjøpesenter",
  "propertyForm_accomodationsCategoryOptions_hotel_motel": "Hotell/Motell",
  "propertyForm_shopCategoryOptions_convenience_store": "Dagligvarebutikk",
  "propertyForm_shopCategoryOptions_department_store": "kjøpesenter",
  "propertyForm_shopCategoryOptions_food_and_drink": "Mat og Drikke",
  "propertyForm_shopCategoryOptions_drugstore_or_pharmacy": "Apotek eller apotek",
  "propertyForm_shopCategoryOptions_electronics": "Elektronikk",
  "propertyForm_shopCategoryOptions_hardware_house_garden": "Jernvarehus hage",
  "propertyForm_shopCategoryOptions_bookstore": "Bokhandel",
  "propertyForm_shopCategoryOptions_clothing_and_accessories": "Klær og tilbehør",
  "propertyForm_shopCategoryOptions_consumer_goods": "Forbruksvarer",
  "propertyForm_shopCategoryOptions_hair_and_beauty": "Hår og skjønnhet",
  "facilitiesForm_standardTypeOptions_hotel_motel": "Hotell/Motell",
  "facilitiesForm_standardTypeOptions_office": "Kontor",
  "facilitiesForm_standardTypeOptions_shopping_mall": "Kjøpesenter",
  "facilitiesForm_standardTypeOptions_shop": "Butikk",
  "facilitiesForm_selectFacilitiesForDataCollection": "2. Velg fasiliteter for datainnsamling",
  "facilitiesForm_preselectedMandatoryItems": "Følgende forhåndsvalgte elementer er obligatoriske",
  "facilitiesForm_mandatoryFacilitiesFor": "Obligatoriske fasiliteter for",
  "facilitiesForm_optionalFacilitiesFor": "Valgfrie fasiliteter for",
  "facilitiesForm_standard": "Standard",
  "facilitiesForm_preselectedOptionalItems": "Følgende elementer er valgfrie",
  "facilitiesForm_faq_mandatoryFacilities": "Hva er obligatoriske fasiliteter?",
  "facilitiesForm_faq_AnswerMandatoryFacilities": "Det er standardfasiliteter som vi finner i eiendommer av ditt slag. For å generere våre tilgjengelighetsdata på en grundig måte, må disse anleggene vurderes. EX inngangen til bygget",
  "facilitiesForm_faq_optionalFacilities": "Hva er valgfrie fasiliteter?",
  "facilitiesForm_faq_AnswerOptionalFacilities": "Dette er en ikke-uttømmende liste over fasiliteter som kan eksistere eller ikke i eiendommen din, men som ikke nødvendigvis er standardfasiliteter i en eiendom som din. For eksempel et spa på et hotell eller i et kjøpesenter.",
  "unitForm_helperText_entrance_key": "Inngang",
  "unitForm_helperText_entrance_value": "dvs. hovedinngang eller sekundærinngang som via restaurant eller hager",
  "unitForm_helperText_lobby_key": "Lobbyen",
  "unitForm_helperText_lobby_value": "dvs. hovedlobbyen til eiendommen inkludert salong eller venteområde",
  "unitForm_helperText_reception_key": "Resepsjon/infoskranke",
  "unitForm_helperText_reception_value": "dvs. hovedinnsjekkingsskranke, conciergeskranke, bagasjeoppbevaring eller informasjonsskranke",
  "unitForm_helperText_facility_key": "Anlegget",
  "unitForm_helperText_facility_value": "",
  "unitForm_helperText_parking_key": "Parkering og nær omgivelser",
  "unitForm_helperText_parking_value": "dvs. hovedparkeringsområde og ytterligere uteområder som hager, oppkjørsler, gangveier",
  "unitForm_helperText_commonAreas_key": "Fellesarealer",
  "unitForm_helperText_commonAreas_value": "Felles fellesområder på hotellet som Lobby Lounge, korridorer osv.",
  "unitForm_helperText_conferenceRoom_key": "Konferanserom / møterom",
  "unitForm_helperText_conferenceRoom_value": "",
  "unitForm_helperText_auditorium_key": "Auditorium",
  "unitForm_helperText_auditorium_value": "Teaterstil, kino etc.",
  "unitForm_helperText_diningArea_key": "Spiseområde",
  "unitForm_helperText_diningArea_value": "f.eks. hovedrestaurant, frokostbufféområde, lobbybar/bistro",
  "unitForm_helperText_toiletRoom_key": "Toalettrom (felles, delt)",
  "unitForm_helperText_toiletRoom_value": "dvs. felles toalett/bad tilgjengelig fra lobbyen, restauranten eller andre offentlige områder",
  "unitForm_helperText_gym_key": "Gym",
  "unitForm_helperText_gym_value": "",
  "unitForm_helperText_spa_key": "Spa",
  "unitForm_helperText_spa_value": "",
  "unitForm_helperText_hospitalityRoom_key": "Type gjestfrihetsrom",
  "unitForm_helperText_hospitalityRoom_value": "dvs. Type rom, f.eks. Enkeltrom, Dobbeltrom, Tilgjengelig, Familie etc",
  "unitForm_quantityLabel": "Velg mengde",
  "unitForm_locationFaq": "Hvor befinner det seg?",
  "unitForm_totalQuantity": "Totalt antall",
  "unitForm_floorSelection": "Velg gulv",
  "unitForm_finishedCreation": "Er du ferdig med å lage enheter?",
  "unitForm_startClassifying": "Spørreundersøkelse!",
  "unitForm_unitData2": "Privat toalett",
  "unitForm_unitData3": "Privat bad",
  "unitForm_unitData4": "Privat kjøkken",
  "unitForm_unitTypeDetails": "3. Enhetstypedetaljer:",
  "unitForm_unitName": "Skriv navnet på enheten din her",
  "unitForm_accessibleUnit": "Denne enheten anses som tilgjengelig",
  "questionUnits_addNewUnit": "Legg til ny enhet",
  "questionUnits_savedInfo": "Informasjonen din ble lagret",
  "questionUnits_removedInfo": "Informasjonen din ble fjernet",
  "questionUnits_resources": "Ressurser",
  "questionUnits_uploadPictures": "Last opp bilder",
  "questionUnits_explanation": "Noen forklaringer / detaljer om denne delen kan gå her",
  "questionUnits_uploadLabel": "LASTE OPP",
  "questionUnits_unitExtraInfo": "Enhet ekstra info",
  "questionUnits_unitExtraInfoPlaceholder1": "Her kan du legge inn private kommentarer til denne spesifikke enheten",
  "questionUnits_unitExtraInfoPlaceholder2": "( for øyeblikket har du ingen kommentarer til denne enheten )",
  "questionUnits_beforeClassification": "Du bør legge til fasiliteter før du begynner å klassifisere",
  "questionUnits_editFacilities": "Rediger fasiliteter",
  "questionUnits_addNew": "Klikk på \"Legg til ny\" eller velg enhet for å begynne å klassifisere",
  "questionUnits_faq1": "Info",
  "questionUnits_faq2": "Hva er obligatoriske fasiliteter?",
  "questionUnits_faq2_1": "Det er standardfasiliteter som vi finner i eiendommer av ditt slag. For å generere våre tilgjengelighetsdata på en grundig måte, må disse anleggene vurderes. EX inngangen til bygget",
  "questionUnits_faq3": "Hva er valgfrie fasiliteter?",
  "questionUnits_faq3_1": "Dette er en ikke-uttømmende liste over fasiliteter som kan eksistere eller ikke i eiendommen din, men som ikke nødvendigvis er standardfasiliteter i en eiendom som din. For eksempel et spa på et hotell eller i et kjøpesenter.",
  "FAR_SelectProperty": "Velg Eiendom",
  "FAR_DocumentPreview": "Forhåndsvisning av dokument:",
  "FAR_DownloadPDF": "Last ned PDF:",
  "FAR_Download": "Last ned nå!",
  "CLP_SelectProperty": "Velg Eiendom",
  "CLP_SelectPropertyForChecklist": "Velg en egenskap for å lage sjekklisten",
  "CLP_AccessibilityChecklist": "Sjekkliste for tilgjengelighet",
  "CLP_GeneratedOn": "Generert på",
  "CLP_GeneratedBy": "Generert av",
  "CLP_LoadingDoc": "Laster dokument...",
  "CLP_DownloadNow": "Last ned nå!",
  "A11yUnitsPageSubTitle": "Ting å huske på",
  "A11yUnitsPageDescription": "Du kan bare knytte enheter som ligner hverandre hvis de er nøyaktig like. Ellers bør en annen enhetstype opprettes.",
  "routes_NewProperty": "Ny eiendom",
  "routes_EditProperty": "Rediger egenskap",
  "routes_EditFacility": "Rediger anlegg",
  "routes_SelectFacilities": "Velg fasiliteter",
  "routes_CreateProperty": "Opprett eiendom",
  "routes_Classify": "Klassifisere",
  "routes_Blank": "Blank",
  "changePassword_success": "Suksess",
  "changePassword_successMessage": "Passordet ditt er oppdatert",
  "changePassword_returnToLogin": "Gå tilbake til pålogging",
  "changePassword_resetPassword": "Tilbakestill passordet ditt",
  "changePassword_newPassword_label": "Nytt passord",
  "changePassword_confirmNewPassword_label": "Bekrefte nytt passord",
  "changePassword_newPasswordRequired_errorMessage": "Nytt passord kreves",
  "changePassword_newPasswordMismatch_errorMessage": "Passordene må være like",
  "changePassword_newPassword_browserTab": "Bytt passord",
  "DocumentationPage_pageTitle": "Dokumentasjonsside",
  "DocumentationPage_tabtitle": "Dokumentasjon",
  "DownloadsPage_pageTitle": "Nedlastingsside",
  "LanguagesDropdown_English": "Engelsk",
  "LanguagesDropdown_French": "fransk",
  "LanguagesDropdown_German": "tysk",
  "LanguagesDropdown_Dutch": "nederlandsk",
  "LocationAutocomplete_searchPlaceholder": "Søk etter steder ...",
  "LocationAutocomplete_validAddress": "Vennligst oppgi husnummer og gate",
  "LocationAutocomplete_addressEmpty": "Adressen kan ikke være tom",
  "page404_PageNotFound": "Side ikke funnet.",
  "page404_PageNotFound_explanation": "Siden du leter etter kan ha blitt fjernet.",
  "page404_PageNotFound_returnHome_button": "Gå tilbake til nettsiden",
  "page500_InternalError": "Intern server feil.",
  "page500_InternalError_explanation": "Servern støter på noe som ikke er tillatt på en sluttfora anmodning.",
  "propertyListPage_NotClassified": "Ikke klassifisert",
  "propertyListIconName_allergy_food_class": "Allergi mat klasse",
  "propertyListIconName_allergy_room_class": "Allergiromsklasse",
  "propertyListIconName_mobility_class": "Mobilitetsklasse",
  "propertyListIconName_hearing_class": "Hørselsklasse",
  "propertyListIconName_cognitive_class": "Kognitiv klasse",
  "propertyListIconName_visual_class": "Visuell klasse",
  "propertyForm_AllStepsCompleted": "Alle trinn fullført",
  "propertyForm_propertyReady": "Eiendommen din er nå klar!",
  "propertyForm_propertyReady_description": "Du har fullført trinnet med eiendomsinformasjon. Du kan redigere denne informasjonen ved å klikke på koblingen Egenskapsliste øverst til venstre.",
  "propertyForm_startClassifying": "START KLASSIFISERING",
  "propertyForm_propertyStepper_step1": "Legg til eiendomsinformasjon",
  "propertyForm_propertyStepper_step2": "Velg fasiliteter",
  "propertyForm_propertyStepper_step3": "Legg til enhetsdetaljer",
  "settingsForms_CompanyInformation_SelectOptions_Service": "Service",
  "settingsForms_CompanyInformation_SelectOptions_Merchandising": "Merchandising",
  "settingsForms_CompanyInformation_SelectOptions_Manufacturing": "Produksjon",
  "settingsForms_CompanyInformation_SelectOptions_Other": "Annen",
  "settingsForms_ImageCantBeChanged": "Dette bildet kan ikke endres",
  "settingsForms_RegNumber_label": "Reg.nummer",
  "settingsForms_InvoiceStatus_label": "Fakturastatus",
  "settingsForms_CompanyName_label": "selskapsnavn",
  "settingsForms_CompanyType_label": "Firma type",
  "settingsForms_CompanySize_label": "Bedriftsstørrelse",
  "settingsForms_CompanyAddress_label": "Firma adresse",
  "settingsForms_ContractDate_label": "Dato for kontraktsignering",
  "settingsForms_SubscriptionPeriod_label": "Abonnementsperiode",
  "settingsForms_Employees_label": "Ansatte",
  "settingsForms_UserInformation_positionOptions_owner": "Eieren",
  "settingsForms_UserInformation_positionOptions_executive": "Executive",
  "settingsForms_UserInformation_positionOptions_manager": "sjef",
  "settingsForms_UserInformation_positionOptions_operations_and_production": "Drift og produksjon",
  "settingsForms_UserInformation_positionOptions_other": "Annen",
  "settingsForms_UserInformation_departmentOptions_it": "DEN",
  "settingsForms_UserInformation_departmentOptions_marketing": "Markedsføring",
  "settingsForms_UserInformation_departmentOptions_finance": "Finansiere",
  "settingsForms_UserInformation_departmentOptions_human_resources": "Menneskelige ressurser",
  "settingsForms_UserInformation_departmentOptions_sales": "Salg",
  "settingsForms_UserInformation_departmentOptions_operations": "Drift",
  "settingsForms_UserInformation_departmentOptions_other": "Annen",
  "settingsForms_UserInformation_title": "brukerinformasjon",
  "settingsForms_UserInformation_UploadPicture": "Last opp bilde",
  "settingsForms_UserInformation_formatRestriction": "Bruk et bilde på minst 128px x 128px i .jpg-format",
  "settingsForms_UserInformation_surname": "Etternavn",
  "settingsForms_UserInformation_position": "Posisjon",
  "settingsForms_UserInformation_department": "Avdeling",
  "settingsPage_pageTitle": "Innstillingsside",
  "settingsPage_breadcrumbs_dashboard": "Dashbord",
  "settingsPage_breadcrumbs_settings": "Innstillinger",
  "signinForm_explanation": "Logg på kontoen din for å fortsette",
  "signinForm_validEmail_error": "Må være en gyldig e-post",
  "signinForm_emailRequired": "E-post er påkrevd",
  "signinForm_generalError": "Noe gikk galt",
  "signinForm_passwordRequired": "Passord er påkrevd",
  "signinForm_emailLabel_textfield": "Epostadresse",
  "signinForm_passwordLabel_textfield": "Passord",
  "signinForm_remberMeCheckbox_textfield": "Husk meg",
  "signinForm_signIn_button": "Logg inn",
  "signinForm_forgotPassword_button": "Glemt passord",
  "signupForm_signUp_button": "Melde deg på",
  "signupForm_signUp_title": "Kom i gang",
  "signupForm_signUp_subTitle": "Begynn å skape en best mulig brukeropplevelse for kundene dine",
  "signupForm_signUp_nameRequired": "Navn er påkrevd",
  "signupForm_signUp_minCharacters_errorMessage": "Må bestå av minst 12 tegn",
  "signupForm_signUp_required_errorMessage": "Obligatorisk",
  "signupForm_signUp_nameLabel": "Navn",
  "signupForm_signUp_companyLabel": "Selskap",
  "signupForm_signUp_emailAddressLabel": "Epostadresse",
  "signupForm_signUp_passwordLabel": "Passord",
  "signupForm_signUp_confirmPasswordLabel": "bekreft passord",
  "statsPage_pageTitle": "Statistikkside",
  "statsPage_cardContent": "Denne siden vil være tilgjengelig i fremtidige versjoner av Accessibility Management System.",
  "resetPassword_inbox": "Sjekk innboksen din",
  "resetPassword_explanation_1": "Vi har sendt en e-post til",
  "resetPassword_explanation_2": "med instruksjoner for gjenoppretting av passord",
  "resetPassword_title": "Tilbakestille passord",
  "resetPassword_subTitle": "Skriv inn e-postadressen din for å tilbakestille passordet ditt",
  "unitForm_title": "Sammensatte enheter",
  "unitForm_floorTitle": "Gulv",
  "unitImagesDialog_labelMANDATORY": "PÅBUDT, BINDENDE",
  "unitImagesDialog_labelOPTIONAL": "VALGFRI",
  "unitImagesDialog_labelPICTURES": "BILDER",
  "unitImagesDialog_dropzone": "Slipp bilder her eller velg en fil",
  "userDropdown_profile": "Profil",
  "userDropdown_signout": "Logg ut",
  "questionUnits_uploadPictures_uploadError": "Det oppsto en feil under opplasting av bildene",
  "questionUnits_uploadSuccess": "Dataene dine er sendt inn",
  "questionUnits_unitExtraInfoLabel": "Ekstra info",
  "questionUnits_unitExtraInfoDelete_button": "Slett",
  "questionUnits_unitExtraInfoSave_button": "Lagre",
  "QuestionnaireCompletionCard_title": "Fullføring av standarder",
  "QuestionnaireCompletionCard_disableMessage": "Du har ingen klassifisering ennå.",
  "QuestionnaireCompletionCard_ParkingCard": "Parkering",
  "QuestionnaireCompletionCard_EntranceCard": "Inngang",
  "QuestionnaireCompletionCard_ToiletCard": "Toalett",
  "QuestionnaireCompletionCard_RoomsCard": "Rom",
  "QuestionnaireCompletionCard_LiftAndElevatorsCard": "Heis og heiser",
  "QuestionnaireCompletionCard_LobbyAndReceptionCard": "Lobby og resepsjon",
  "FAR_Report": "Tilgjengelighetsrapport",
  "FAR_TableUnitName": "Enhetsnavn",
  "FAR_TableDescription": "Beskrivelse",
  "CLP_PleaseSelectProperty": "Velg eiendom",
  "CLP_BrowserTabTitle": "Full tilgjengelighetsrapport",
  "CLP_UnitMandatoryLabel": "Påbudt, bindende",
  "CLP_UnitDoneLabel": "FERDIG",
  "propertyPage_Controllers_SearchDoc": "Søk i dokumentasjon",
  "generalWords_Yes": "Ja",
  "generalWords_No": "Nei",
  "generalWords_Next": "Neste",
  "generalWords_Close": "Lukk",
  "generalWords_Reset": "Nullstille",
  "generalWords_Back": "Tilbake",
  "generalWords_Finish": "Bli ferdig",
  "generalWords_NextStep": "Neste steg",
  "generalWords_Edit": "Redigere",
  "generalWords_Download": "nedlasting",
  "generalWords_Delete": "Slett",
  "generalWords_SaveChanges": "Lagre endringer",
  "generalWords_Selected": "valgt",
  "generalWords_Required": "Obligatorisk",
  "customerSupportPage_title": "Kundestøtteside",
  "customerSupportPage_emailLabel": "Kontakt kundestøtte på:",
  "unitForm_helperText_entrance": "dvs. hovedinngang eller sekundærinngang som via restaurant eller hager.",
  "unitForm_helperText_lobby": "dvs. hovedlobbyen på eiendommen inkludert salong eller venteområde.",
  "unitForm_helperText_reception": "dvs. hovedinnsjekkingsskranke, conciergeskranke, bagasjeoppbevaring eller informasjonsskranke.",
  "unitForm_helperText_facility": "dvs. navnet på anlegget eller eiendommen.",
  "unitForm_helperText_parking": "dvs. hovedparkeringsområde og ytterligere uteområder som hager, oppkjørsler, gangveier.",
  "unitForm_helperText_conferenceRoom": "Et konferanserom er et stort rom hvor flere personer kan ha en konferanse.",
  "unitForm_helperText_auditorium": "Teaterstil, kino etc.",
  "unitForm_helperText_diningArea": "f.eks. hovedrestaurant, frokostbufféområde, lobbybar/bistro.",
  "unitForm_helperText_toiletRoom": "dvs. felles toalett/bad tilgjengelig fra lobbyen, restauranten eller andre offentlige områder.",
  "unitForm_helperText_gym": "Fysiske øvelser og aktiviteter utført inne, ofte med utstyr.",
  "unitForm_helperText_spa": "Sted hvor man kan slappe av gjennom badstue, basseng og boblebad.",
  "unitForm_helperText_hospitalityRoom": "dvs. Type rom, f.eks. Enkeltrom, Dobbeltrom, Tilgjengelig, Familie etc.",
  "unitForm_helperText_shopping_aisle": "dvs. gang mellom hyllene.",
  "unitForm_helperText_counter": "En jevn overflate (som et bord, en hylle eller en montre) som transaksjoner utføres over.",
  "unitForm_helperText_checkout_pay": "f.eks Checkout, Self Checkout, Self-scanning checkout.",
  "unitForm_helperText_fitting_room": "Et rom i en butikk der kundene kan ta på seg et klesplagg for å se om det passer før de kjøper det.",
  "unitForm_helperText_manned_kiosk": "En kontantutveksling eller innløsningsterminal, som gir mulighet for kontanter og kontantløse transaksjoner med en kasserer.",
  "unitForm_helperText_floor": "dvs. tilgjengeligheten på ulike nivåer som Heis i 1 etasje, Grønn heis ved inngang 2.",
  "unitForm_helperText_playground": "Et område som brukes av barn til å leke i. De har vanligvis utstyr som sklier, husker og vipper som barna kan leke på.",
  "unitForm_helperText_garden": "En plass, vanligvis utendørs, avsatt for dyrking, fremvisning og glede av planter og andre former for natur.",
  "unitForm_helperText_bathroom_common": "Et rom som inneholder badekar eller dusj og vanligvis en vask og toalett.",
  "unitForm_helperText_bathroom__private": "Et privat rom med badekar eller dusj og vanligvis vask og toalett.",
  "unitForm_helperText_quiet_room": "Et stillerom eller stillerom er et rom bygget med hensyn til stillhet ved å skjerme støy fra eller mot omgivelsene.",
  "unitForm_helperText_kitchen_common": "Et offentlig rom hvor man kan tilberede og lage mat.",
  "unitForm_helperText_toilet_room__private": "dvs. privat toalett tilgjengelig fra lobby, restaurant eller andre offentlige områder.",
  "unitForm_helperText_kitchen__private": "Et privat rom hvor man kan tilberede og lage mat.",
  "unitForm_helperText_conferenceRoom_": "",
  "routes_Services": "Tjenester",
  "routes_Help": "Hjelp",
  "routes_Clp": "Sjekkliste",
  "routes_Far": "Tilgjengelighetsrapport",
  "FAR_WhatIsItTitle": "Hva er en tilgjengelighetsrapport?",
  "FAR_WhatIsItDescription": "Tilgjengelighetsrapporten er en rapport som vi genererer for deg avhengig av hvor tilgjengelig eiendommen din er. Nedenfor kan du velge en eiendom og laste ned PDF-rapporten.",
  "FAR_MoreInfo": "For mer informasjon om tilgjengelighetsrapporten vennligst",
  "FAR_SelectPropertyForChecklist": "Velg en egenskap for å opprette rapporten",
  "CLP_noChecklistFound": "Vi fant ingen liste for denne eiendommen",
  "CLP_WhatIsItTitle": "Hva er en sjekkliste?",
  "CLP_WhatIsItDescription": "Sjekklisten er en liste basert på tilgjengelighetssystemets inventarinformasjon. Den viser forbedringsområdene, basert på dine innspill i systemet. En forhåndsvisning av dokumentet er tilgjengelig og kan lastes ned eller skrives ut.",
  "CLP_MoreInfo": "For mer informasjon om sjekklisten vennligst",
  "CLP_FAR_ConsultTheDocumentation": "konsultere dokumentasjonen",
  "LanguagesDropdown_Swedish": "svensk",
  "LanguagesDropdown_Danish": "dansk",
  "gettingStartedCard_step1_link": "Lese",
  "gettingStartedCard_step2_link": "nedlasting",
  "gettingStartedCard_step3_link": "Kryss av",
  "contactForm_category": "Kategori",
  "contactForm_title": "Kontakt oss",
  "contactForm_chooseImg": "Velg bilde",
  "contactForm_submitBtn": "Send forespørsel",
  "contactForm_attachBtnLabel": "Hvis mulig, vennligst legg ved et skjermbilde.",
  "contactForm_messageLabel": "Vennligst beskriv forespørselen din her.",
  "contactForm_messageEmptyError": "Legg til en melding",
  "contactForm_categoryOptions_ServiceInquiry": "Tjenesteforespørsel",
  "contactForm_categoryOptions_TechnicalIssues": "Tekniske problemer",
  "contactForm_categoryOptions_OtherInquires": "Andre henvendelser",
  "contactForm_subtitle1": "Hvis du ikke finner svaret du leter etter, er vi her for å hjelpe.",
  "contactForm_subtitle2": "Skriv til oss! Vi vil komme tilbake til deg så snart som mulig.",
  "FAR_noDataAvalible_1": "Tilgjengelighetsrapport kan ikke genereres ennå for denne egenskapen. Vennligst fullfør",
  "FAR_noDataAvalible_2": "til",
  "FAR_noDataAvalible_3": "først.",
  "CLP_Updating": "Oppdaterer...",
  "CLP_AreYouSure": "Er du sikker?",
  "CLP_UpdateMessage": "Hvis du gjør dette, vil elementet forsvinne fra sjekklisten og standarden vil automatisk oppdateres som gjenspeiler endringen.",
  "CLP_Cancel": "AVBRYT",
  "CLP_YesUpdate": "JA, OPPDATERING",
  "CLP_WhatIsAChecklist": "Hva er en sjekkliste?",
  "CLP_Name": "Navn",
  "CLP_pdfDisclaimer": "Merk: Når du har gjort forbedringene, ikke glem å oppdatere tilgjengelighetsdataene dine i standarddelen.",
  "CLP_FAR_noAccessibilityDataAvailable1": "Vi har ingen tilgjengelighetsdata tilgjengelig.",
  "CLP_noChecklist1": "Sjekklisten kan ikke genereres ennå for denne egenskapen. Svar på spørsmålene inne i",
  "CLP_noChecklist2": "standard seksjon",
  "CLP_noChecklist3": "til",
  "CLP_noChecklist4": "først.",
  "CLP_FAR_noAccessibilityDataAvailable2": "Opprett en eiendom",
  "CLP_FAR_noAccessibilityDataAvailable3": "og svar på spørsmålene i standarddelen først.",
  "statsPage_subscriptionExpiring": "Abonnementet utløper om",
  "statsPage_days": "dager",
  "statsPage_contactCustomerSupport": "Kontakt kundestøtte",
  "statsPage_companyInformation": "Firmainformasjon",
  "statsPage_numberOfPhotosUploaded": "Antall bilder lastet opp",
  "statsPage_photos": "bilder",
  "statsPage_totalAmountProperties": "Totalt antall eiendommer",
  "statsPage_amountCompleted": "Beløp fullført",
  "statsPage_actionsPerVisitor": "Handlinger per besøkende på widgeten",
  "statsPage_yourItems": "Varene dine",
  "statsPage_name": "Navn",
  "statsPage_sku": "SKU",
  "statsPage_quantity": "Mengde",
  "statsPage_numberOfUnits": "Antall enheter",
  "statsPage_accessible": "Tilgjengelig",
  "statsPage_notAccessible": "Ikke tilgjengelig",
  "statsPage_unit": "Enhet",
  "statsPage_amount": "Beløp",
  "statsPage_incomplete": "Ufullstendig",
  "statsPage_completed": "Fullført",
  "statsPage_notCompleted": "Ikke fullført",
  "statsPage_mobility": "Mobilitet",
  "statsPage_cognitive": "Kognitiv",
  "statsPage_hearing": "Hørsel",
  "statsPage_visual": "Visuell",
  "statsPage_allergy": "Allergi",
  "statsPage_class": "Klasse",
  "statsPage_totalAccessibilityDatapoints": "Totale tilgjengelighetsdatapunkter",
  "statsPage_visitorsThatOpened": "Besøkende som åpnet widgeten",
  "statsPage_visitorsInteraction": "Totalt antall handlinger på widgeten",
  "statsPage_action": "Handling",
  "statsPage_clicks": "Klikk",
  "statsPage_noDataAvailable_topText": "Det er ingen data tilgjengelig",
  "statsPage_noDataAvailable_bottomText": "For øyeblikket",
  "statsPage_company_address": "Adresse",
  "statsPage_company_city": "By",
  "statsPage_company_country": "Land",
  "statsPage_company_name": "Navn",
  "statsPage_company_type": "Type",
  "statsPage_company_registration_number": "Registreringsnummer",
  "statsPage_company_logo": "Logo",
  "statsPage_company_employees": "Ansatte",
  "statsPage_company_empty_fields": "Tomme felt",
  "settingsPage_alertMsgImageUpload": "Klikk lagre for å oppdatere profilbildet ditt",
  "settingsPage_alertMsgCompanyInformation_1": "Kontakt",
  "settingsPage_alertMsgCompanyInformation_2": "Kundeservice",
  "settingsPage_alertMsgCompanyInformation_3": "hvis du trenger å gjøre endringer i bedriftsinformasjonen.",
  "documentationPage_downloadDocument": "Last ned dokument",
  "documentationPage_loadingDocument": "Laster dokument",
  "CLP_Status": "Status",
  "CLP_lastUpdate": "Siste oppdatering",
  "CLP_completed": "fullført",
  "CLP_incomplete": "ufullstendig",
  "LanguagesDropdown_Languages": "Språk",
  "login_welcome_message": "Velkommen til Accessibility Management System 👋",
  "CLP_Checklist_is_generated_based": "Sjekklisten genereres basert på tilgjengelighetsdataene vi samler inn fra eiendommen din. Den viser forbedringsområdene, og når du krysser av, oppdateres svaret automatisk i systemet og tilgjengelighetsdataene dine endres. Dokumentet kan lastes ned for eksternt bruk. For mer informasjon",
  "CLP_Go_to_checklist": "Gå til sjekkliste",
  "CLP_Updated_date": "Oppdatert dato",
  "CLP_The_purpose_of_Handiscover_1": "Hensikten med Handiscovers inventar og sjekkliste er å veilede deg når du forbedrer tilgjengeligheten. Den vedlagte listen består av flere elementer. Ut fra perspektivet at noe skal være tilgjengelighetstilpasset, er det punkter som er obligatoriske. I tillegg identifiserer vi punkter som vi anbefaler om man skal bygge nytt eller pusse opp.",
  "CLP_List_points": "List opp punkter",
  "CLP_Priority": "Prioritet",
  "CLP_User": "Bruker",
  "CLP_Mandatory": "Påbudt, bindende",
  "CLP_Need_help": "Trenger hjelp? Kontakt teamet vårt",
  "CLP_Handiscovers_suggestions": "Handiscover sine forslag",
  "propertyForm_nextStep_tooltip": "Fyll ut alle obligatoriske felt først",
  "statsPage_See_photos": "Se bilder",
  "statsPage_Your_subscription": "Ditt abonnement",
  "statsPage_Filter_data_from": "Filtrer data fra",
  "statsPage_Filter_data_to": "Filtrer data til",
  "statsPage_to": "til",
  "statsPage_Reload": "Last inn på nytt",
  "statsPage_Business_Metrics": "Forretningsmålinger",
  "statsPage_Service_Metrics": "Tjenesteberegninger",
  "statsPage_Statistics_page": "Statistikk side",
  "imagesPage_Pictures_List": "Bildeliste",
  "imagesPage_Search_by_name": "Søk etter navn",
  "imagesPage_No_pictures_available": "Ingen bilder tilgjengelig",
  "imagesPage_Name": "Navn",
  "imagesPage_Display_in_widget": "Vis i widget",
  "imagesPage_Type": "Type",
  "imagesPage_Update_date": "Oppdater dato",
  "imagesPage_Mandatory": "Påbudt, bindende",
  "imagesPage_Are_your_sure": "Er du sikker?",
  "imagesPage_Delete": "Slett",
  "imagesPage_Yes": "Ja",
  "imagesPage_Cancel": "Avbryt",
  "imagesPage_Open_image": "Åpne bilde",
  "imagesPage_Edit": "Redigere",
  "imagesPage_Delete_image": "Slett bildet",
  "CLP_The_purpose_of_Handiscover_2": "Vi har også tatt med punkter som er \"Enkle\" å fikse, men som sannsynligvis er viktige fra ett tilgjengelighetsperspektiv.",
  "a11yUnits_The_title_has_been_translated": "Tittelen er oversatt",
  "statsPage_Statistics": "Statistikk",
  "customerSupportPage_thankYou": "Takk skal du ha!",
  "customerSupportPage_requestSuccessfully": "Forespørselen din er sendt. Vår kundestøtte vil ta seg av forespørselen din og komme tilbake til deg så snart som mulig.",
  "customerSupportPage_warning": "Advarsel",
  "customerSupportPage_error": "Feil",
  "propertyListPage_showAll": "Vis alt",
  "propertyListPage_completed": "Fullført",
  "propertyListPage_incomplete": "Ufullstendig",
  "dashboard": "Dashbord",
  "widget": "Widget",
  "property_type": "Eiendomstype",
  "category": "Kategori",
  "edit_widget": "Rediger widget",
  "created": "Opprettet",
  "published": "Publisert",
  "unpublished": "Upublisert",
  "widget_info": "Tilgjengelighetswidgeten viser detaljerte tilgjengelighetsdata som tidligere er logget i Accessibility Management System. Denne widgeten gjør det mulig å skape bedre forutsetninger for besøkende å planlegge oppholdet på forhånd ved å se tilgjengeligheten. Tilgjengelighetswidgeten er interaktiv ettersom all data som er oppdatert i systemet, spilles av i widgeten.",
  "view_live_widget": "Se live widget",
  "no_widget_data_message": "Vi har ikke widgetdata. Ta kontakt med vårt kundeserviceteam.",
  "image_list": "Bildeliste",
  "language_setting": "Språk innstillinger",
  "history": "Historie",
  "select_accessibility_unit": "Velg Tilgjengelighetsenhet",
  "add_new_image": "Legg til nytt bilde",
  "order": "Rekkefølge",
  "image": "Bilde",
  "description": "Beskrivelse",
  "accessibility_unit": "Tilgjengelighetsenhet",
  "accessibility": "tilgjengelighet",
  "displayed_in_widget": "Vises i widget",
  "current_image": "Gjeldende bilde",
  "upload_new_picture": "Last opp nytt bilde",
  "image_description": "Bildebeskrivelse",
  "image_order": "Bildebestilling",
  "back_to_list": "Tilbake til listen",
  "no_picture": "Ikke noe bilde",
  "please_write_the_text_in": "Skriv gjerne inn teksten",
  "yes_delete": "JA, SLETT",
  "delete_warning_text": "Hvis du gjør dette, vil elementet forsvinne fra widgeten og standarden vil automatisk oppdateres som gjenspeiler endringen.",
  "select_language_the_widget_provide": "Velg språket widgeten gir",
  "changed_by": "Endret av",
  "activity": "Aktivitet",
  "showing": "Viser",
  "of": "av",
  "items": "gjenstander",
  "questionnaire": "Spørreskjema",
  "we_are_showing_followings": "Vi viser følgende i widgeten din",
  "we_are_recommended_to_state": "Vi anbefales å oppgi litt praktisk informasjon i widgeten for besøkende til eiendommen din. Hvis du ønsker å redigere den, vennligst kontakt vår kundeservice",
  "select_what_you_want_to_show": "Velg hva du vil vise i widgeten",
  "practical_information": "Praktisk informasjon",
  "you_can_add_maximum": "Du kan legge til maksimalt 3 setninger",
  "for_the_best_experiences_in_widget": "For de beste opplevelsene i Widget, vil vi hjelpe deg hvis du ønsker å legge til mer informasjon",
  "if_you_do_this_the_item_will_disappear": "Hvis du gjør dette, vil elementet forsvinne fra widgeten",
  "you_can_write_free_texts": "Du kan skrive fritekster for å legge til generell informasjon om nødvendig. Maks 40 tegn",
  "write_a_new_information": "Skriv ny informasjon",
  "you_can_drag_and_drop_the_block": "Du kan dra og slippe blokken for å endre ordrene. Velg avmerkingsboksen for å presentere i widgeten.",
  "you_can_freely_change_the_images_ordering": "Du kan fritt endre bilderekkefølgen ved å dra og slippe.",
  "preview": "Forhåndsvisning",
  "add_point_on_map": "Legg til punkt på kartet",
  "LanguagesDropdown_Spanish": "Spansk",
  "LanguagesDropdown_Norwegian": "Norsk",
  "LanguagesDropdown_Portuguese": "Portugisisk",
  "LanguagesDropdown_Ukrainian": "Ukrainsk",
  "main_unit_image": "Bilde(r) av hovedenheten",
  "item_pictures": "Bilder av varen",
  "please_choose_a_main_unit_image": "Velg et bilde av hovedenheten",
  "please_choose_a_item_picture": "Vennligst velg et bilde av varen",
  "button_settings_updated": "Knappinnstillingene har blitt oppdatert",
  "button_settings_created": "Knappinnstillingene har blitt opprettet",
  "button_settings": "Knappinnstillinger",
  "webmaster_instruction": "Instruksjon for nettredaktører",
  "contract_has_expired": "Kontrakten din er utløpt. Widgeten har blitt suspendert. Kontakt kundestøtte",
  "webmaster_instructions_are_not_available": "Instruksjoner for nettredaktører er ikke tilgjengelige for øyeblikket. Kontakt kundestøtte",
  "create_api_key": "Opprett API-nøkkel for dette selskapet",
  "standard_instruction": "Standard instruksjon",
  "google_tag_manager_instruction": "Instruksjoner for Google Tag Manager"
}